import type { FaireProductEntity } from "../../entity_types/product";

export const p_8vxmp2y5an: FaireProductEntity = {
  token: "p_8vxmp2y5an",
  type: "product",
  name: "Garden Party Matchbook",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/baf4474a5ba748dd1d7c8357995bbc65152308c1db3e978897e688060ac578fb.png",
  galleryImageUrls: [],
  priceDollars: 3,
  description: "A matchbook perfect for celebrating, lighting candles, setting the vibes in your home, office, or on the go. This matchbook features 10 matches, each printed with an ingredient or icon, and vibrant green strike heads to match. \n",
  tags: [],
  msrpDollars: 6,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:34:00.221Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
